import { useMutation } from '../../index';
import permissions from '../../Apollo/permissions';
import { buildVariables, mutation } from './build-ajs-file-mutation-builder';
import { useUserContext } from '@ion/user';

export default function useBuildAjsFile(options = {}) {
  const { currentOrg } = useUserContext();
  const [executeMutation, response] = useMutation(mutation, {
    ...options,
    context: { permission: permissions.updatePipelineAJSBuilder },
  });

  const buildAjsFileMutation = ({ settingsJson }) => {
    settingsJson.clientName = currentOrg.name;
    return executeMutation({ variables: buildVariables({ settingsJson }) });
  };

  return [buildAjsFileMutation, response];
}
